import { render, staticRenderFns } from "./how_it_works.vue?vue&type=template&id=109a6fd0&scoped=true&"
import script from "./how_it_works.vue?vue&type=script&lang=ts&"
export * from "./how_it_works.vue?vue&type=script&lang=ts&"
import style0 from "./how_it_works.vue?vue&type=style&index=0&id=109a6fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a6fd0",
  null
  
)

export default component.exports